var map = {
	"./Base.vue": 7214,
	"./Button/Back.vue": 3150,
	"./Button/Company.vue": 3721,
	"./Button/General.vue": 4346,
	"./Button/Icon.vue": 7627,
	"./Button/Steam.vue": 7672,
	"./Character.vue": 9868,
	"./Dialog.vue": 2477,
	"./Dialog/Cookie.vue": 3763,
	"./Example.vue": 9344,
	"./Footer.vue": 7273,
	"./Header.vue": 677,
	"./HeaderBasic.vue": 5279,
	"./Image.vue": 7103,
	"./LaurelGrid.vue": 4959,
	"./MailchimpForm.vue": 8791,
	"./Modal.vue": 5974,
	"./Modal/Login.vue": 5870,
	"./Module/ArrivingOnConsoles.vue": 251,
	"./Module/BuyNowSteam.vue": 3012,
	"./Module/HeroLaurel.vue": 1899,
	"./Module/HeroRibbon.vue": 6462,
	"./NavigationBar.vue": 6205,
	"./Preloader.vue": 5274,
	"./Quotes.vue": 9428,
	"./Ribbon.vue": 5949,
	"./Slide.vue": 7191,
	"./Slide/Character.vue": 9989,
	"./Slide/Trait.vue": 4532,
	"./Sprite.vue": 9614,
	"./TraitGrid.vue": 1915,
	"./Ui/FallenKing.vue": 7982,
	"./Ui/Logo.vue": 2645,
	"./Ui/ProgressBar.vue": 4036,
	"./Ui/SpaceCity.vue": 9044,
	"./Ui/SpeechBubble.vue": 3090,
	"./Ui/SpeechBubbleWithCharacter.vue": 9464,
	"./Ui/Tile.vue": 1428,
	"./Ui/Tooltip.vue": 7592,
	"./Ui/Trait.vue": 6008,
	"./VideoPlayer.vue": 6405
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8756;